import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'

export const useInvalidateTransactions = () => {
  const queryClient = useQueryClient()

  const invalidateTransactions = useCallback(async () => {
    await queryClient.invalidateQueries(QueryKeys.Transactions)
  }, [queryClient])

  return { invalidateTransactions }
}
